import Vue from 'vue'
import Vuex from 'vuex'
import vehicles from './modules/vehicles/vehicles'
import booking from './modules/booking'
import stepping from './modules/stepping'
import quotation from './modules/quotation'
import points from './modules/points'
import auth from './modules/auth'
import user from './modules/user'
import registration from './modules/registration'
import contact from './modules/contact'
import ui from './modules/ui'
import businessSearch from './modules/businessSearch'
import offers from './modules/offers'
import leads from './modules/leads'
import drivers from './modules/drivers'
import popins from './modules/popins'

Vue.use(Vuex)

export const storeConfig = {
  modules: {
    vehicles,
    booking,
    stepping,
    quotation,
    auth,
    points,
    contact,
    registration,
    user,
    ui,
    businessSearch,
    offers,
    leads,
    drivers,
    popins,
  },
  state: {
    layout: null,
    api: '/api',
    isNavOpen: false,
    degradedMode: false,
  },
  mutations: {
    LAYOUT_INITIALIZATION(state, payload) {
      state.layout = payload
    },
    TOGGLE_NAV(state) {
      state.isNavOpen = !state.isNavOpen
    },
    SET_DEGRADED_MODE_TRUE(state) {
      state.degradedMode = true
    },
  },
}

export default new Vuex.Store(storeConfig)
